export default "__VITE_ASSET__ZShOsRr8__"